<h1 mat-dialog-title class="text-center text-3xl mb-3">{{ text }}</h1>

<div mat-dialog-content>
  <div class="bg-red-50 border-l-4 border-red-500 p-4 rounded-lg space-y-3">
    <div class="flex items-center space-x-2">
      <span class="text-red-600 text-xl">⚠️</span>
      <p class="text-red-700 font-semibold">Profile Deletion Notice</p>
    </div>

    <div class="flex items-start space-x-2 text-gray-700">
      <span class="text-red-500">•</span>
      <span>All saved data will be permanently erased.</span>
    </div>

    <div class="flex items-start space-x-2 text-gray-700">
      <span class="text-red-500">•</span>
      <span>All registered programs will be removed.</span>
    </div>

    <div class="flex items-start space-x-2 text-gray-700">
      <span class="text-red-500">•</span>
      <span>All associated children and their enrollment details will be deleted.</span>
    </div>

    <div class="flex items-start space-x-2 text-gray-700">
      <span class="text-red-500">•</span>
      <span>Any program fees you have paid are <strong>non-refundable</strong>.</span>
    </div>

    <p class="text-red-600 font-semibold mt-4">
      This action cannot be undone.
    </p>
  </div>
</div>


<div class="text-center mt-8">
  <!-- Cancel Button -->
  <button
    mat-flat-button
    class="mat-focus-indicator ml-3 mat-flat-button mat-button-base"
    (click)="onNoClick()"
  >
    <span class="mat-button-wrapper">Cancel</span>
    <span matripple class="mat-ripple mat-button-ripple"></span>
    <span class="mat-button-focus-overlay"></span>
  </button>

  <!-- Delete Profile Button -->
  <button
    mat-flat-button
    (click)="cancel()"
    class="mat-focus-indicator ml-3 mat-flat-button mat-button-base mat-warn"
  >
    <span class="mat-button-wrapper">Delete Profile</span>
    <span matripple class="mat-ripple mat-button-ripple"></span>
    <span class="mat-button-focus-overlay"></span>
  </button>
</div>
